export default {
      id: "bike_scooter-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#bike_scooter",
      toString: function () {
        return this.url;
      }
    }